/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

export * from 'lit-html/directives/unsafe-mathml.js';
